<template>
  <div class="component--application--detail--functional-action">
    <div class="action-container">
      <template v-if="matchUserPrivilege(privileges, dataType.PrivilegeCode.GENERATE_NEW_LOAN, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="teal"
              tile
              slot="activator"
              class="width-100 height-40 ma-0 generate"
              @click="generateLoan"
              v-on="on"
              :disabled = generateBtn.showBtn
            >
              <v-icon color="white">repeat</v-icon>
            </v-btn>
          </template>
          <span>Generate Loan</span>
        </v-tooltip>
      </template>
      <template v-if="matchUserPrivilege(privileges, dataType.PrivilegeCode.ADD_NOTES, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              slot="activator"
              class="width-100 height-40 ma-0"
              @click="showDialog('ADD_NOTES')"
              tile
              v-on="on"
            >
              <v-icon>library_books</v-icon>
            </v-btn>
          </template>
          <span>Add Notes</span>
        </v-tooltip>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.FOLLOW_UP, dataType.PrivilegeType.EXECUTABLE) && !assist.tool.isWithdrawnStatus(loan.loanStatus)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary" dark slot="activator" class="width-100 height-40 ma-0" @click="showDialog('FOLLOW_UP')"
              tile
              v-on="on">
              <v-icon>add_alarm</v-icon>
            </v-btn>
          </template>
          <span>Follow Up</span>
        </v-tooltip>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.SEND_EMAIL, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              slot="activator"
              class="width-100 height-40 ma-0"
              @click="showDialog('SEND_EMAIL')"
              tile
              v-on="on"
            >
              <v-icon>email</v-icon>
            </v-btn>
          </template>
          <span>Send Email</span>
        </v-tooltip>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.ADD_DOCUMENTS, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on }"
          >
            <v-btn
              color="primary"
              dark
              slot="activator"
              class="width-100 height-40 ma-0"
              @click="showDialog('ADD_DOCUMENT')"
              tile
              v-on="on"
            >
              <v-icon>library_add</v-icon>
            </v-btn>
          </template>
          <span>Add Documents</span>
        </v-tooltip>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.RFE, dataType.PrivilegeType.EXECUTABLE)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary" dark slot="activator" class="width-100 height-40 ma-0" @click="showDialog('RFE')"
              tile
              v-on="on">
              <v-icon>picture_as_pdf</v-icon>
            </v-btn>
          </template>
          <span>RFE</span>
        </v-tooltip>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.EXPRESS, dataType.PrivilegeType.EXECUTABLE) && isOperation('EXPRESS')">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary" dark slot="activator" class="width-100 height-40 ma-0" @click="doExpress"
              tile
              v-on="on">
              <v-icon>restore</v-icon>
            </v-btn>
          </template>
          <span>Express</span>
        </v-tooltip>
      </template>
      <!-- <template v-if="isShowElement(privileges, dataType.PrivilegeCode.AUTO_FORWARD_TO_UNDERWRITER_AFTER_SIGNED_LOAN_AGREEMENT, dataType.PrivilegeType.EXECUTABLE) && !assist.tool.isWithdrawnStatus(loan.loanStatus)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :color="vaFlag.color"
              dark
              slot="activator"
              class="width-100 height-40 ma-0"
              @click="doVerbalAgreement"
              tile
              v-on="on"
            >
              <v-icon>spellcheck</v-icon>
            </v-btn>
          </template>
          <span>Auto Forward</span>
        </v-tooltip>
      </template> -->
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.PAYMENT_PLAN_EMULATOR, dataType.PrivilegeType.EXECUTABLE) && !assist.tool.isWithdrawnStatus(loan.loanStatus)">
        <payment-plan-emulator-dialog
          :loan="loan"
          :slaveLoanId="slaveLoanId"
        ></payment-plan-emulator-dialog>
      </template>
      <template v-if="isShowElement(privileges, dataType.PrivilegeCode.DIAL, dataType.PrivilegeType.EXECUTABLE)  && !assist.tool.isWithdrawnStatus(loan.loanStatus)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary" dark slot="activator" class="width-100 height-40 ma-0" @click="doDial"
              tile
              v-on="on">
              <v-icon>phone_in_talk</v-icon>
              <span class="dial-daily-count">{{ dialCount.dialDailyCount }}</span>
              <span class="dial-total-count">{{ dialCount.dialTotalCount }}</span>
            </v-btn>
          </template>
          <span>Dial</span>
        </v-tooltip>
      </template>
    </div>

    <!-- dialog -->
    <v-dialog max-width="41%" v-model="dialog.generateDialog">
      <v-card>
        <v-card-title class="generate-card">
          <span class="headline">GENERATE</span>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="basic.loanStatus" row>
            <v-radio
              v-for="(item, index) in basic.restrict"
              :label="item.text"
              :value="item.value"
              :key="index"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog.generateDialog = false">Close</v-btn>
          <v-btn color="primary" @click="generateLoan">Go for it</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.addNotes" persistent max-width="50%">
      <add-notes-dialog :loan="loan" @hideDialog="hideDialog"></add-notes-dialog>
    </v-dialog>

    <v-dialog v-model="dialog.followUp" persistent max-width="50%">
      <follow-up-dialog :loanId="loan.id" @hideDialog="hideDialog"></follow-up-dialog>
    </v-dialog>

    <v-dialog v-model="dialog.sendEmail" persistent max-width="70%">
      <send-email-dialog :loan="loan" :loanId="loan.id" :loanPhase="assist.dataType.LoanPhaseEnum.LOAN_ORIGINATION.value"  @hideDialog="hideDialog"></send-email-dialog>
    </v-dialog>

    <v-dialog v-model="dialog.addDocument" persistent max-width="50%">
      <add-document-dialog :loanId="loan.id" @hideDialog="hideDialog"></add-document-dialog>
    </v-dialog>

    <v-dialog v-model="dialog.rfeDialog" persistent max-width="40%">
      <rfe-dialog :loan="loan" @hideDialog="hideDialog"></rfe-dialog>
    </v-dialog>

    <v-dialog v-model="dialog.remoteConsentDialog" persistent max-width="30%">
      <remote-consent-dialog :loanId="loan.id" @hideDialog="hideDialog"></remote-consent-dialog>
    </v-dialog>
  </div>
</template>

<script>
import SendEmailDialog from '@/components/panda/common/dialog/functionalAction/SendEmailDialog'
import AddDocumentDialog from '@/components/panda/common/dialog/functionalAction/AddDocumentDialog'
import AddNotesDialog from '@/components/panda/common/dialog/functionalAction/AddNotesDialog'
import FollowUpDialog from '@/components/panda/common/dialog/functionalAction/FollowUpDialog'
import RfeDialog from '@/components/panda/common/dialog/functionalAction/RfeDialog'
import RemoteConsentDialog from '@/components/panda/common/dialog/functionalAction/RemoteConsentDialog'
import { Authentication, DataType, Tool, Crypto, Popup, Cache } from '@/util/index'
import { LoanOperationApi, OriginationApi, OriginationBusinessApi } from '@/api/pandaria'
import Swal from 'sweetalert2'
import PaymentPlanEmulatorDialog from '../../common/dialog/functionalAction/PaymentPlanEmulatorDialog'
const tool = new Tool()
const popup = new Popup()
const cache = new Cache()
export default {
  name: 'application-detail-functional-action',
  inject: ['reload'],
  components: {
    PaymentPlanEmulatorDialog,
    AddDocumentDialog,
    SendEmailDialog,
    AddNotesDialog,
    FollowUpDialog,
    RfeDialog,
    RemoteConsentDialog
  },
  props: {
    loan: Object,
    slaveLoanId: Number,
    privileges: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      assist: {
        tool: tool,
        dataType: DataType
      },
      generateNew: false,
      dialog: {
        followUp: false,
        sendEmail: false,
        addDocument: false,
        addNotes: false,
        generateDialog: false,
        rfeDialog: false,
        remoteConsentDialog: false
      },
      basic: {
        loanStatus: '',
        restrict: []
      },
      dialCount: {
        dialDailyCount: 0,
        dialTotalCount: 0
      },
      vaFlag: {
        color: 'primary',
        verbalAgreementFlag: 0
      },
      dataType: DataType,
      currentLockedId: -1,
      generateBtn: {
        showBtn: false,
        timer: null
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  created () {
    this.showGenerateBtn()
  },
  watch: {
    loanId () {
      this.getDialCount(this.loan.id)
      this.fetchVerbalAgreementFlag(this.loan.loanNo)
    }
  },
  destroyed () {
    this.$eventBus.$off('broadcastLockedId')
    this.$eventBus.$off('broadcastAutoGenerateLoan')
  },
  mounted () {
    this.$eventBus.$on('broadcastLockedId', target => {
      this.currentLockedId = target
    })
    this.$eventBus.$on('broadcastAutoGenerateLoan', target => {
      this.doGenerateLoan(target.loanStatus, DataType.Category.NEW_CUSTOMER.value, target.updatedStatus, true)
    })
    this.$eventBus.$on('changeSignStatus', target => {
      if (this.loanId === target.loanId && target.signStatus === DataType.SignStatusEnum.VOIDED.value) {
        this.fetchVerbalAgreementFlag(this.loan.loanNo)
      }
    })
  },
  methods: {
    isOperation (action) {
      let result = false
      const loanStatus = this.loan.loanStatus
      switch (action) {
        case 'EXPRESS': {
          result = tool.whetherDoExpress(loanStatus)
          break
        }
        default:
          break
      }
      return result
    },
    showGenerateDialog () {
      this.dialog.generateDialog = true
    },
    showGenerateBtn () {
      const $this = this
      $this.generateBtn.showBtn = true
      $this.generateBtn.timer = setTimeout(function () {
        $this.generateBtn.showBtn = false
        clearTimeout($this.generateBtn.timer)
        $this.generateBtn.timer = null
      }, 20000)
    },
    async generateLoan () {
      const $this = this
      this.basic.restrict = []
      const authorization = this.store.getters.getAuthorization
      const roleCode = $this.store.getters.getRoleCode
      const restrictValueArray = []
      let idGenerate = [
        DataType.LoanStatus.AGENT_REVIEW.value,
        DataType.LoanStatus.UNDERWRITER_REVIEW.value,
        DataType.LoanStatus.CORRECTOR_REVIEW.value,
        DataType.LoanStatus.TRIBE_REVIEW.value
      ]
      if (tool.isEmpty(roleCode)) {
        popup.popupForWarning('Please wait a minute')
        return
      } else if (roleCode === DataType.RoleEnum.RETENTION_AGENT.code) {
        idGenerate = [
          DataType.LoanStatus.NEGATIVE_WITHDRAWN.value,
          DataType.LoanStatus.POSITIVE_WITHDRAWN.value
        ]
      } else if (roleCode === DataType.RoleEnum.RETENTION_CUSTOMER_POC.code) {
        idGenerate.push(DataType.LoanStatus.NEGATIVE_WITHDRAWN.value, DataType.LoanStatus.POSITIVE_WITHDRAWN.value)
      } else if (roleCode === DataType.RoleEnum.ORIGINATION_AGENT.code) {
        idGenerate = [DataType.LoanStatus.AGENT_REVIEW.value]
      } else if (roleCode === DataType.RoleEnum.CORRECTION_AGENT.code) {
        idGenerate = [DataType.LoanStatus.CORRECTOR_REVIEW.value]
      }

      const loanStatusArray = []
      for (const item of authorization.restricts) {
        if (!loanStatusArray.includes(item.loanStatus) && idGenerate.includes(item.loanStatus)) {
          restrictValueArray.push(item)
          loanStatusArray.push(item.loanStatus)
        }
      }
      for (const restrictValue of restrictValueArray) {
        const restrict = {
          value: restrictValue.loanStatus,
          text: $this.assist.tool.getLoanStatus(restrictValue.loanStatus)
        }
        $this.basic.restrict.push(restrict)
      }

      const restrictLength = this.basic.restrict.length
      let loanStatus
      // TODO Use new customer as default category. To use different categories depending on the situation
      const category = DataType.Category.NEW_CUSTOMER.value

      if (restrictLength >= 1) {
        if (restrictLength === 1) {
          if (this.generateNew === false) {
            popup.popupForQuestion('Are you sure to generate a new loan?', null, function () {
              $this.generateNew = true
              $this.generateLoan()
            })
            return
          } else {
            loanStatus = this.basic.restrict[0].value
          }
        } else {
          if (this.dialog.generateDialog === false) {
            this.showGenerateDialog()
            return
          } else {
            loanStatus = this.basic.loanStatus
          }
        }
        if (tool.isEmpty(loanStatus)) {
          popup.popupForWarning('You need to select the type of loan')
          return
        }

        this.doGenerateLoan(loanStatus, category)
      } else {
        popup.popupForWarning('Generate failed, please contact your manager')
      }
    },
    doGenerateLoan (loanStatus, category, updatedStatus, isAutoGenerate) {
      const _this = this
      // const portfolioList = _this.store.getters.getAccount.portfolioIdList
      const portfolioList = _this.$store.getters.getRuntimePortfolio
      this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.GENERATE_LOAN.value)
      LoanOperationApi.generate(loanStatus, portfolioList, category, function (result) {
        const loanId = tool.isNotEmpty(result) ? result : ''
        if (tool.isNotEmpty(loanId) && _this.loan.loanId !== loanId) {
          cache.setSessionLoanId(Crypto.encrypt(loanId))
          _this.reload()
        } else {
          popup.popupForWarning('There are not enough loans')
        }
      }, function (err) {
        if (err.code === DataType.AjaxResultCodeEnum.GENERATE_IN_SHORT_TIME.value) {
          Swal.fire({
            html:
              '<i class="fad fa-mug-hot text-light-blue alert-icon"></i><p class="alert-text m-t-20">You are generating leads too aggressively.</p><p class="alert-text">Please re-retry in a few seconds.</p>',
            focusConfirm: false
          })
        } else {
          popup.popupForWarning(err.message)
          if (isAutoGenerate) {
            _this.$eventBus.$emit('updateStatus', { updatedStatus })
            _this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.STATUS_CHANGED.value })
            popup.popupForWarning('There are not enough loans')
          }
        }
      })
    },
    showDialog (type) {
      switch (type) {
        case 'FOLLOW_UP':
          this.dialog.followUp = true
          break
        case 'SEND_EMAIL':
          this.dialog.sendEmail = true
          break
        case 'ADD_DOCUMENT':
          this.dialog.addDocument = true
          break
        case 'ADD_NOTES':
          this.dialog.addNotes = true
          break
        case 'RFE':
          this.dialog.rfeDialog = true
          break
        case 'REMOTE_CONSENT':
          this.dialog.remoteConsentDialog = true
          break
        default:
          break
      }
    },

    hideDialog (type) {
      switch (type) {
        case 'FOLLOW_UP':
          this.dialog.followUp = false
          break
        case 'SEND_EMAIL':
          this.dialog.sendEmail = false
          break
        case 'ADD_DOCUMENT':
          this.dialog.addDocument = false
          break
        case 'ADD_NOTES':
          this.dialog.addNotes = false
          break
        case 'RFE':
          this.dialog.rfeDialog = false
          break
        case 'REMOTE_CONSENT':
          this.dialog.remoteConsentDialog = false
          break
        default:
          break
      }
    },

    doExpress () {
      const $this = this
      popup.popupForQuestion('Do you want to express this loan?', null, function () {
        OriginationBusinessApi.express({ loanId: $this.loan.id }, function (result) {
          cache.setSessionLoanId(Crypto.encrypt(result))
          if ($this.$route.path.includes('/pre-origination/application')) {
            $this.reload()
          } else {
            $this.$router.replace('/pre-origination/application')
          }
        },
        function (result) {
          popup.popupForWarning(result.message)
        }
        )
      })
    },

    fetchVerbalAgreementFlag (loanNo) {
      const $this = this
      OriginationBusinessApi.getVerbalAgreementFlag(loanNo, function (result) {
        const vaData = result
        $this.vaFlag = {
          color: tool.isNotEmpty(vaData) && vaData.verbalAgreementFlag === 1 ? 'red' : 'primary',
          verbalAgreementFlag: tool.isNotEmpty(vaData) && vaData.verbalAgreementFlag === 1 ? 1 : 0
        }
      })
    },

    doVerbalAgreement () {
      const latestPersonalStamp = this.$store.getters.getLatestPersonalStamp
      if (tool.isNotEmpty(latestPersonalStamp) && latestPersonalStamp.code === DataType.StampReasonEnum.PERSONAL_REMOTE_CONSENT.value) {
        this.showDialog('REMOTE_CONSENT')
      }
      const updateVerbalAgreementFlag = this.vaFlag.verbalAgreementFlag === 1 ? 0 : 1
      const $this = this

      const cacheData = {}
      cacheData.loanNo = this.loan.loanNo
      cacheData.verbalAgreementFlag = updateVerbalAgreementFlag
      cacheData.loanId = this.loan.id

      OriginationBusinessApi.cacheVerbalAgreementFlag(cacheData, function () {
        $this.vaFlag = {
          color: $this.vaFlag.verbalAgreementFlag === 1 ? 'primary' : 'red',
          verbalAgreementFlag: $this.vaFlag.verbalAgreementFlag === 1 ? 0 : 1
        }
      })
    },

    getDialCount (loanId) {
      const $this = this
      OriginationApi.getDialData(loanId, function (result) {
        const countData = result
        if (tool.isNotEmpty(countData)) {
          const dialDailyCount = countData.dialDailyCount
          const dialTotalCount = countData.dialTotalCount
          $this.dialCount = {
            dialDailyCount: tool.isNotEmpty(dialDailyCount) ? dialDailyCount : 0,
            dialTotalCount: tool.isNotEmpty(dialTotalCount) ? dialTotalCount : 0
          }
        }
      })
    },

    doDial () {
      const $this = this
      popup.popupForQuestion('Please confirm if you need dial', null, function () {
        const loanId = $this.loan.id
        OriginationApi.addDialData(loanId, function () {
          $this.getDialCount(loanId)
        })
      })
    },
    matchUserPrivilege (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    isShowElement (privileges, code, value) {
      return this.matchUserPrivilege(privileges, code, value) && Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    }
  }
}
</script>

<style lang="css" scoped>
  .action-container .v-btn {
    margin-left: 3px !important;
  }
  .action-container .v-btn:first-child {
    margin-left: 0 !important;
  }
  .action-container .generate{
     margin-right: 200px !important;
  }

  .dial-daily-count {
    position: absolute;
    right: -22px;
    top: -8px;
    display: block;
    background: #f44336;
    line-height: 20px;
    font-weight: 500;
    padding: 0;
    color: #fff;
    text-align: center;
    font-size: 13px;
    min-width: 22px;
    height: 20px;
  }

  .dial-total-count {
    position: absolute;
    right: -22px;
    bottom: -8px;
    display: block;
    background: #009688;
    line-height: 20px;
    font-weight: 500;
    padding: 0;
    color: #fff;
    text-align: center;
    font-size: 13px;
    min-width: 22px;
    height: 20px;
  }

  .generate-card {
    background-color: #00b8d4;
  }

  .alert-icon {
    font-size: 40px;
  }
  .alert-text {
    font-size: 20px;
    font-weight: 500;
    margin-top: 5px;
  }
</style>
